import { render, staticRenderFns } from "./LADTable.vue?vue&type=template&id=0b20ecae&"
import script from "./LADTable.vue?vue&type=script&lang=js&"
export * from "./LADTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports